<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 12v-2h2v2H8Zm6 0v-2h2v2h-2ZM3 22v-8h1v-4c0-1.1.208-2.138.625-3.112a8.029 8.029 0 0 1 1.713-2.55 8.029 8.029 0 0 1 2.55-1.713A7.837 7.837 0 0 1 12 2c1.1 0 2.137.208 3.113.625a8.029 8.029 0 0 1 2.55 1.713 8.03 8.03 0 0 1 1.712 2.55C19.792 7.862 20 8.9 20 10v4h1v8H3Zm2-2h2v-4H5v4Zm4 0h2v-4H9v4Zm-3-6h5V4.075c-1.433.233-2.625.904-3.575 2.013C6.475 7.196 6 8.5 6 10v4Zm7 0h5v-4c0-1.5-.475-2.804-1.425-3.912-.95-1.109-2.142-1.78-3.575-2.013V14Zm0 6h2v-4h-2v4Zm4 0h2v-4h-2v4Z"
    />
  </svg>
</template>
